module.exports = __webpack_public_path__ + "img/自控设备.0a6dd994.gif";